module.exports = __webpack_public_path__ + "static/media/check.21d0c432.svg";